import styled from "styled-components";

// checkout needs background EAEAEA
export const StyledScrollable = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow-y: auto;
    z-index: 1;
    flex-grow: 1;
`;